import React, { FC } from 'react';
import styled from 'styled-components';
import { ImageSource } from 'types/imageSource';
import { Copyright } from 'client/components/Copyright';
import LanguageSwitcher from '../../common/components/LanguageSwitcher';
import { RoundLogo } from '../../common/components/RoundLogo';

const FrameworkContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  width: 400px;
  padding: 15px;
`;

const Whiteboard = styled.div<{ withLogo: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border-radius: 16px;
  background-color: white;
  padding: 15px;
  padding-top: ${({ withLogo }) => (withLogo ? '75px' : '15px')};
  margin-top: ${({ withLogo }) => (withLogo ? '15px' : '0px')};
  margin-bottom: 15px;
`;

interface FrameworkProps {
  locales: string[];
  logo: ImageSource;
  color: string;
}

export const Framework: FC<FrameworkProps> = ({
  locales,
  logo,
  color,
  children
}) => {
  const logoExists = logo.src !== '' || logo.fallback !== '';
  return (
    <FrameworkContainer>
      <div>
        <LanguageSwitcher companyLanguages={locales} />
        <Whiteboard withLogo={logoExists}>
          {logoExists && <RoundLogo source={logo} />}
          {children}
        </Whiteboard>
      </div>
      <Copyright color={color} />
    </FrameworkContainer>
  );
};
